class TC_Links {
    constructor () {
        if ($('.frontpage-blog-section').length) {
            this.initBlogLinkEvents();
        }

        if ($('.target-blank').length) {
            this.initTargetBlankEvents();
        }

        if ($('.footer-menu-left').length) {
            this.initFooterLinkEvents();
        }

        if ($('.cr-logout-link').length) {
            this.initLogoutLink();
        }
    }

    initBlogLinkEvents () {
        let links = $('.frontpage-blog-section a');

        links.each((i, link) => {
            link = $(link);

            link.on('click', e => {
                if ($(window).outerWidth() >= 1040 && $(document.body).hasClass('is-frontpage')) {
                    e.preventDefault();
                    let win = window.open(link.attr('href'), '_blank');
                    
                    if (win) {
                        win.focus();
                    }
                }
            });
        });
    }

    initTargetBlankEvents () {
        let links = $('.target-blank');

        links.each((i, link) => {
            link = $(link);

            link.on('click', e => {
                if ($(window).outerWidth() >= 1040 && $(document.body).hasClass('is-frontpage')) {
                    e.preventDefault();
                    let win = window.open(link.attr('href'), '_blank');
                    
                    if (win) {
                        win.focus();
                    }
                }
            });
        });
    }

    initFooterLinkEvents () {
        let links = $('.footer-menu-left a');

        links.each((i, link) => {
            link = $(link);

            link.on('click', e => {
                if ($(window).outerWidth() >= 1040 && $(document.body).hasClass('is-frontpage')) {
                    e.preventDefault();
                    let win = window.open(link.attr('href'), '_blank');
                    
                    if (win) {
                        win.focus();
                    }
                }
            });
        });
    }

    initLogoutLink () {
        $('.cr-logout-link').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            $('.cr-logout-form').submit();
        });
    }
}
